<template>
  <v-menu offset-y :close-on-content-click="true" nudge-bottom="8" content-class="user-menu-content">
    <template v-slot:activator="{ attrs, on }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        text
        class="user-menu-trigger"
      >
        <div class="user-info-container">
          <!-- Display Name for larger screens -->
          <span v-if="$vuetify.breakpoint.smAndUp" class="user-name">
            {{ stateUser().name }}
          </span>
          <!-- User Avatar -->
          <v-avatar size="36" class="user-avatar">
            <v-icon color="white" size="20">mdi-account-circle</v-icon>
          </v-avatar>
        </div>
      </v-btn>
    </template>

    <v-list class="user-dropdown" elevation="3">
      <!-- User Header -->
      <div class="user-header">
        <div class="user-header-avatar">
          <v-avatar size="48" class="header-avatar">
            <v-icon color="white" size="28">mdi-account-circle</v-icon>
          </v-avatar>
        </div>
        <div class="user-header-info">
          <div class="user-header-name">
            {{ stateUser().name }}
          </div>
          <div v-if="structure" class="user-header-structure">
            {{ structure }}
          </div>
        </div>
      </div>
      
      <v-divider class="menu-divider"></v-divider>

      <!-- Menu Actions -->
      <div class="menu-actions">
        <!-- Profile Menu Item -->
        <v-list-item @click="goToProfile" class="menu-action-item">
          <v-list-item-icon class="menu-icon">
            <v-icon size="20" color="#5a6c7d">mdi-account-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="menu-action-text">
              {{ $t("userMenu.profile") }}
            </v-list-item-title>
          </v-list-item-content>
          <v-icon size="16" color="#bdc3c7">mdi-chevron-right</v-icon>
        </v-list-item>

        <!-- Logout Menu Item -->
        <v-list-item @click="logoutClick" class="menu-action-item logout-item">
          <v-list-item-icon class="menu-icon">
            <v-icon size="20" color="#e74c3c">mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="menu-action-text logout-text">
              {{ $t("userMenu.logout") }}
            </v-list-item-title>
          </v-list-item-content>
          <v-icon size="16" color="#e74c3c">mdi-chevron-right</v-icon>
        </v-list-item>
      </div>
    </v-list>
  </v-menu>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "UserMenu",
  data() {
    return {
      language: "en",
    };
  },
  computed: {
    structure() {
      if (this.stateUser().admin) {
        return this.stateUser().admin.structure?.name;
      } else if (this.stateUser().employee) {
        return this.stateUser().employee.structure?.name;
      }
      return null;
    },
  },
  methods: {
    ...mapActions(["logout"]),
    ...mapGetters(["stateUser"]),
    goToProfile() {
      this.$router.push({
        name: "profile",
      });
    },
    logoutClick() {
      this.logout();
    },
  },
};
</script>

<style scoped>
/* 2025 Modern Flat Design - Clean & Professional */

/* User Menu Trigger Button */
.user-menu-trigger {
  height: 40px !important;
  min-width: auto !important;
  padding: 0 12px !important;
  margin: 0 !important;
  background-color: rgba(255, 255, 255, 0.08) !important;
  border-radius: 8px !important;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
}

.user-menu-trigger:hover {
  background-color: rgba(255, 255, 255, 0.12) !important;
}

.user-info-container {
  display: flex;
  align-items: center;
  gap: 10px;
}

.user-name {
  font-family: 'Inter', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
  color: #ffffff;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.2px;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-avatar {
}

/* Dropdown Menu */
.user-menu-content {
  border-radius: 12px !important;
  overflow: hidden;
}

.user-dropdown {
  min-width: 260px;
  border-radius: 12px;
  padding: 0;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

/* User Header Section */
.user-header {
  padding: 18px 16px;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  display: flex;
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);
}

.user-header-avatar {
  flex-shrink: 0;
}

.header-avatar {
  background: linear-gradient(135deg, #5a6c7d 0%, #34495e 100%) !important;
  border: 3px solid white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.user-header-info {
  flex: 1;
  min-width: 0;
}

.user-header-name {
  font-family: 'Inter', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 15px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-header-structure {
  font-family: 'Inter', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 12px;
  color: #7f8c8d;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.menu-divider {
  margin: 0 !important;
}

.menu-actions {
  padding: 6px;
}

/* Menu Action Items */
.menu-action-item {
  padding: 10px 12px;
  min-height: 44px;
  cursor: pointer;
  border-radius: 8px;
  margin-bottom: 2px;
}

.menu-action-item:last-child {
  margin-bottom: 0;
}

.menu-action-item:hover {
  background-color: #f8f9fa;
}

.logout-item:hover {
  background-color: rgba(231, 76, 60, 0.06);
}

.menu-icon {
  margin-right: 10px !important;
  min-width: 20px !important;
}

.menu-action-text {
  font-family: 'Inter', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #2c3e50;
}

.logout-text {
  color: #e74c3c;
  font-weight: 600;
}

/* Responsive Design */
@media (max-width: 600px) {
  .user-menu-trigger {
    height: 36px !important;
    padding: 0 6px !important;
    min-width: 36px !important;
    width: 36px !important;
  }
  .user-avatar {
    width: 28px !important;
    height: 28px !important;
  }
  .user-info-container {
    gap: 4px;
  }
  .user-menu-trigger .v-icon {
    font-size: 16px !important;
  }
  
  .user-dropdown {
    min-width: 220px;
  }
  
  .header-avatar {
    width: 36px !important;
    height: 36px !important;
  }
  
  .user-header {
    padding: 12px 10px;
  }
  .menu-action-item {
    padding: 8px 10px;
    min-height: 40px;
  }
}
</style>
